import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockPreComputedContent"] */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlockPreComputedContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Demo"] */ "/opt/build/repo/docs/src/components/Demo/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Link.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/HeadingLink.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Kbd/Kbd.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/accordion/demos/_index.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/QuickNav/QuickNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferenceTable"] */ "/opt/build/repo/docs/src/components/ReferenceTable/ReferenceTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownLink"] */ "/opt/build/repo/docs/src/components/Subtitle/MarkdownLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Subtitle/Subtitle.css");
;
import(/* webpackMode: "eager", webpackExports: ["ViewSourceLink"] */ "/opt/build/repo/docs/src/components/Subtitle/ViewSourceLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Head","Body","Row","RowHeader","ColumnHeader","Cell"] */ "/opt/build/repo/docs/src/components/Table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypePropRef"] */ "/opt/build/repo/docs/src/components/TypePropRef/TypePropRef.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypeRef"] */ "/opt/build/repo/docs/src/components/TypeRef/TypeRef.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/css/mdx-components.css");
;
import(/* webpackMode: "eager", webpackExports: ["TypeCode"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.26_@types+react@19.2.14_next@16.2.12_@babel+core_28a3063e1cac6c1792ff64277e172ed5/node_modules/@mui/internal-docs-infra/abstractCreateTypes/TypeCode.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.26_@types+react@19.2.14_next@16.2.12_@babel+core_28a3063e1cac6c1792ff64277e172ed5/node_modules/@mui/internal-docs-infra/CodeHighlighter/CodeHighlighterClient.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useCodeFallback"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.26_@types+react@19.2.14_next@16.2.12_@babel+core_28a3063e1cac6c1792ff64277e172ed5/node_modules/@mui/internal-docs-infra/CodeHighlighter/useCodeFallback.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CoordinatedLazyClient"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.26_@types+react@19.2.14_next@16.2.12_@babel+core_28a3063e1cac6c1792ff64277e172ed5/node_modules/@mui/internal-docs-infra/CoordinatedLazy/CoordinatedLazyClient.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.2.12_@babel+core@7.29.7_supports-color@10.2.2__@playwright+test@1.59.1_@types+n_ca915961cbc9f1ffe1ddb04274cfc8a8/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionHeader"] */ "/opt/build/repo/packages/react/src/accordion/header/AccordionHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionItem"] */ "/opt/build/repo/packages/react/src/accordion/item/AccordionItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionPanel"] */ "/opt/build/repo/packages/react/src/accordion/panel/AccordionPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionRoot"] */ "/opt/build/repo/packages/react/src/accordion/root/AccordionRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionTrigger"] */ "/opt/build/repo/packages/react/src/accordion/trigger/AccordionTrigger.tsx");
